<template>
    <div>

<section class="content">
<div class="container-fluid">

        <div class="row clearfix">

            <div class="bg-light-green" style="margin-top:-1% !important;">
                <!-- <br> -->
                <div class="row paddingku">
                    <div class="col-md-6 searching">
                        <span class="h_page">Permasalahan Pembangunan</span> <br> <br>
                    </div>
                    <div class="col-md-3">

                    </div>
                    <div class="col-md-3 searching">
                        <div class="input-group">
                            <span class="input-group-btn">
                                <button  type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                            </span>
                            <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                        </div> <br>
                    </div>
                </div>
            </div>


            <div class="col-xs-12 card">
        <!-- ============================================================ MULAI ======================================================================== -->

                <!-- HEADER -->
                <br>
                <div class="row">
                    <div class="col-md-6">
                        <span class="huruf_input">Periode RPJMD</span>
                        <select @change="getData()" v-model="data.rpjmd_id" class="form-control show-tick" tabindex="-98">
                            <option value="" >-- Semua Periode --</option>
                            <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id"> {{data.periode}}</option>
                        </select>
                    </div>

                    <div class="col-md-6">
                        <span class="huruf_input">Bidang Urusan</span>
                        <select  @change="getData()" v-model="data.bidang_urusan_pemerintahan_id" class="form-control show-tick" tabindex="-98">
                            <option value="" >-- Semua Bidang --</option>
                            <option v-for="(data) in list_bidang" :key="data.bidang_urusan_pemerintahan_id" v-bind:value="data.bidang_urusan_pemerintahan_id"> 	&#91;{{data.kode_bidang}}&#93;	{{data.nama_bidang}}</option>
                        </select>
                    </div>



                </div>
                <br>
                <!-- HEADER END -->
                <div class="table-responsive">
                    <table class="table table-bordered" style="width: 100%">
                        <thead>
                        <tr class="bg-success kepala_table_f text-center">
                            <th class="text-center h_tengah" style="width: 5%">No</th>
                            <th class="text-center h_tengah" style="width: 40%">Uraian Permasalahan</th>
                            <th class="text-center h_tengah" style="width: 40">Keterangan</th>
                            <th class="text-center h_tengah" style="width: 15%">Pilihan</th>
                        </tr>
                        </thead>
                        <tbody>
                            <tr v-if="cek_load_data">
                                <td colspan="4" class="text-center">
                                    <img src="images/loading-plan.gif" width="450px">
                                </td>
                            </tr>
                            <template v-if="!cek_load_data">
                                <tr class="h_isitable" v-for="(data) in list_permasalahan" :key="data.permasalahan_pembangunan_id">
                                    <td class="text-center">{{data.no_permasalahan}}</td>
                                    <td>{{data.uraian}}</td>
                                    <td>{{data.keterangan}}</td>
                                    <td class="tabel_center text-center" >
                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.permasalahan_pembangunan_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>
                                    </td>
                                </tr>
                            </template>
                            <tr v-if="list_permasalahan==0">
                                <td class="text-center" colspan="5"><strong>DATA KOSONG</strong></td>
                            </tr>

                        </tbody>
                    </table>
                </div>

                <hr>
                  <div class="text-center">
                      <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                              <i class="material-icons">skip_previous</i>
                      </button>
                      &nbsp;
                      <span style="font-size: 85%; color: #a5a5a5"><b>{{page_first}} - {{page_last}}</b></span>
                      &nbsp;
                      <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                              <i class="material-icons">skip_next</i>
                      </button>
                  </div>
                <hr>

                <!-- ============================================================ MODAL ======================================================================== -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-blue">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                </div>

                            <form @submit.prevent="addData()">

                                <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Periode RPJMD</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                            <div class="form-line">
                                            <select v-model="data.rpjmd_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Periode RPJMD --</option>
                                                <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                                            </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Bidang Urusan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                            <div class="form-line">
                                            <select v-model="data.bidang_urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Bidang Urusan Pemerintahan --</option>
                                                <option v-for="(data) in list_bidang" :key="data.bidang_urusan_pemerintahan_id" v-bind:value="data.bidang_urusan_pemerintahan_id"> 	&#91;{{data.kode_bidang}}&#93;	{{data.nama_bidang}}</option>
                                            </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">No Permasalahan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="data.no_permasalahan" type="number" class="form-control" placeholder="Ex : 01" :required="true">
                                        </div>
                                        </div>
                                    </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian Permasalahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.uraian" type="text" class="form-control" :required="true" placeholder="Ex : Masih terdapat guru yang belum memiliki kualifikasi pendidikan S1/D4">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan </label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                    <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                        <div class="modal-dialog modal-lg" role="document">
                            <div class="modal-content">
                                <div class="modal-header bg-light-green">
                                    <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span></button>
                                    <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                </div>
                            <form @submit.prevent="editData()">
                                <div class="modal-body">

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Periode RPJMD</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                            <div class="form-line">
                                            <select v-model="data.rpjmd_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Periode RPJMD --</option>
                                                <option v-for="(data) in list_rpjmd" :key="data.rpjmd_id" v-bind:value="data.rpjmd_id">	{{data.periode}}</option>
                                            </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Bidang Urusan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                            <div class="form-line">
                                            <select v-model="data.bidang_urusan_pemerintahan_id" :required="true" class="form-control show-tick" tabindex="-98">
                                                <option value="" :disabled="true">-- Pilih Bidang Urusan Pemerintahan --</option>
                                                <option v-for="(data) in list_bidang" :key="data.bidang_urusan_pemerintahan_id" v-bind:value="data.bidang_urusan_pemerintahan_id"> 	&#91;{{data.kode_bidang}}&#93;	{{data.nama_bidang}}</option>
                                            </select>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row clearfix">
                                    <div class="col-md-2 form-control-label">
                                        <label for="kode">No Permasalahan</label>
                                    </div>
                                    <div class="col-md-10">
                                        <div class="form-group">
                                        <div class="form-line">
                                            <input v-model="data.no_permasalahan" type="number" class="form-control" placeholder="Ex : 01" :required="true">
                                        </div>
                                        </div>
                                    </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Uraian Permasalahan</label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <input v-model="data.uraian" type="text" class="form-control" :required="true" placeholder="Ex : Masih terdapat guru yang belum memiliki kualifikasi pendidikan S1/D4">
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="row clearfix">
                                        <div class="col-md-2 form-control-label">
                                            <label for="kode">Keterangan </label>
                                        </div>
                                        <div class="col-md-10">
                                            <div class="form-group">
                                                <div class="form-line">
                                                    <textarea v-model="data.keterangan" rows="4" class="form-control no-resize" placeholder="Masukan Keterangan..."></textarea>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                                <div class="modal-footer">
                                    <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                    <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                </div>
                            </form>
                            </div>
                        </div>
                    </div>
                  <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                <!-- ============================================================ MODAL ======================================================================== -->




        <!-- ============================================================ MULAI ======================================================================== -->
            </div>

        </div>

        </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL = URL_APP+'api/v1/planning_permasalahan_pembangunan/';
    const ADD_URL_BID = URL_APP+'api/v1/planning_bidang/';

    export default {
        name: "planning_urusan",
        data() {
            return {
                data:{
                  permasalahan_pembangunan_id:'',
                  rpjmd_id: '',
                  bidang_urusan_pemerintahan_id: '',
                  no_permasalahan: '',
                  uraian: '',
                  keterangan: '',
                  tujuan_id: ''
                },
                permasalahan_pembangunan_id:'',
                rpjmd_id: '',
                bidang_urusan_pemerintahan_id: '',
                no_permasalahan: '',
                uraian: '',
                keterangan: '',
                tujuan_id: '',
                filter_rpjmd: '',
                filter_bidang: '',
                list_rpjmd: [],
                list_bidang: [],
                list_permasalahan: [],
                page_first : 1,
                page_last : 0,
                cari_value : '',
                cek_load_data : true,
            };
        },

        mounted() {
            this.getDataRPJMD();
            this.getDataBidang();
            this.getData();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'create', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then(res => res.json()).then((data_urusan) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },

            getDataRPJMD: function(){
                fetch(ADD_URL_RPJMD+'readDataNoPaging', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                  this.list_rpjmd = data_rpjmd.data;
                  this.data.rpjmd_id = this.list_rpjmd[0].rpjmd_id; 

                })
            },
            getDataBidang: function(){
                fetch(ADD_URL_BID+'readDataNoPaging', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((data_rpjmd) => {
                    // console.log(data_rpjmd);
                  this.list_bidang = data_rpjmd.data;
                  this.data.bidang_urusan_pemerintahan_id = this.list_bidang[0].bidang_urusan_pemerintahan_id;
                })
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                        data_ke : this.page_first,
                        cari_value : this.cari_value,
                        rpjmd_id: this.data.rpjmd_id,
                        bidang_urusan_pemerintahan_id: this.data.bidang_urusan_pemerintahan_id,

                    })
                }).then((res) => res.json()).then((data_urusan) => {
                  this.list_permasalahan = data_urusan.data;
                  this.page_last = data_urusan.jml_data;
                  this.cek_load_data = false;
                })
            },
            editData: function(){
                fetch(ADD_URL+'update', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify(this.data)
                }).then((res_data) => {
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                // console.log(data);
                this.data = {
                  permasalahan_pembangunan_id: data.permasalahan_pembangunan_id,
                  rpjmd_id: data.rpjmd_id,
                  bidang_urusan_pemerintahan_id: data.bidang_urusan_pemerintahan_id,
                  no_permasalahan: data.no_permasalahan,
                  uraian: data.uraian,
                  keterangan: data.keterangan,
                  tujuan_id: data.tujuan_id
                };
                // this._id = a;
                // this.rpjmd_id = b;
                // this.bidang_id = c;
                // this.no = d;
                // this.uraian = e;
                // this.keterangan = f;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"delete", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.data = {
                    rpjmd_id: '',
                    bidang_id: '',
                    no: '',
                    uraian: '',
                    keterangan: '',
                };
            },

            //PAGINASI
            alertku : function(type, title){
              this.$swal({
                type: type,
                title: title,
                showConfirmButton: false,
                timer: 800
              });
            },

            btn_prev : function(){
                this.cek_load_data = true;
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                this.cek_load_data = true;
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.cek_load_data = true;
                this.page_first = 1;
                this.getData();
            }
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
